import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationContent = ({
  nPages,
  currentPage,
  recordsPerPage,
  skip,
  setSkip,
  setCurrentPage,
  total,
}) => {
  const pageNumbers = [...Array((nPages || 1) + 1).keys()].slice(1);

  const firstPage = (event) => {
    event.preventDefault();
    if (currentPage === 1) return;

    setSkip(0);
    setCurrentPage(1);
  };

  const lastPage = (event) => {
    event.preventDefault();
    if (currentPage === nPages) return;

    setSkip(nPages * recordsPerPage - recordsPerPage);
    setCurrentPage(nPages);
  };

  const previousPage = (event) => {
    event.preventDefault();
    if (currentPage === 1) return;

    setSkip(skip - recordsPerPage);
    setCurrentPage(currentPage - 1);
  };

  const nextPage = (event) => {
    event.preventDefault();
    if (currentPage === nPages) return;

    setSkip(skip + recordsPerPage);
    setCurrentPage(currentPage + 1);
  };

  const changePage = (event, pageNumber) => {
    event.preventDefault();
    if (pageNumber === currentPage) return;
    setSkip(pageNumber * recordsPerPage - recordsPerPage);
    setCurrentPage(pageNumber);
  };

  return (
    <div className="d-flex justify-content-start mt-3">
      <Pagination>
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink first onClick={(event) => firstPage(event)} />
        </PaginationItem>
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink previous onClick={(event) => previousPage(event)} />
        </PaginationItem>
        {pageNumbers.map((pageNumber) => (
          <PaginationItem active={currentPage === pageNumber} key={pageNumber}>
            <PaginationLink onClick={(event) => changePage(event, pageNumber)}>
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={currentPage === nPages}>
          <PaginationLink next onClick={(event) => nextPage(event)} />
        </PaginationItem>
        <PaginationItem disabled={currentPage === nPages}>
          <PaginationLink last onClick={(event) => lastPage(event)} />
        </PaginationItem>
        {total > 0 && (
          <PaginationItem disabled={true}>
            <PaginationLink>Total: {total} registros</PaginationLink>
          </PaginationItem>
        )}
      </Pagination>
    </div>
  );
};

export default PaginationContent;
